import { Component, OnInit } from '@angular/core';
import {
	Data, DataLoaderService, CommonDataService, AlternateOptionsService, SortingService,
	PriceCalculationService, ProgressBarService, SummaryValidationService, SummaryService
} from '../service-call-index';
import { SummaryValidationComponent } from './../summary-validations/summary-validations.component';
import { AlternateScreenComponent } from '../../alternate-options/alternate-options.component';

@Component({
	selector: 'rim-options',
	templateUrl: './rim.template.html',
	styleUrls: ['./rim.component.css'],
})

export class RimOptions implements OnInit {
	public rim: Data[];
	public saved: Data[];
	private flag: boolean = false;
	public toggleContViewRim: boolean = false;
	public currency: string;
	public rimSuggList = [];
	public errMessage;
	public lengthOfRim: number;

	constructor(private dataLoaderService: DataLoaderService, private commonDataService: CommonDataService, private sortingService: SortingService,
		private summaryService: SummaryService, private summaryValidationService: SummaryValidationService,
		private priceCalculationService: PriceCalculationService, private alternateOptionsService: AlternateOptionsService,
		private summaryValidationComponent: SummaryValidationComponent, private progressService: ProgressBarService, private alternateScreenComponent: AlternateScreenComponent) {
		this.currency = this.dataLoaderService.data.currencyType;
		this.rim = this.dataLoaderService.data.rim;
	}
	ngOnInit() {
		this.summaryService.getSelectedOptions();
		this.summaryValidationService.getSelectedOptions();

		this.progressService.progressBarValidation();

		if (this.commonDataService.rimFlag) {
			this.toggleContViewRim = true;
		}

		//fetching length for displaying in HTML
		this.lengthOfRim = this.dataLoaderService.data.rim.length;

		//On load	
		let rim;
		this.rim.forEach(element => {
			if (element.selected === true) {
				rim = element;
				this.saved = rim;
				this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalRim", data: [rim] });
			}
		});
	}
	/**
	 * To select a color option and send the selected option to the Summary screen
	 * @param item of Data type
	 * @returns none
	 */

	selectRim(item) {
		setTimeout(() => {
			this.progressService.illuminateRed();
		}, 0);

		this.dataLoaderService.flagDictionary.loadingFlag = true;
		this.dataLoaderService.flagDictionary.resetRimFlag = false;
		this.progressService.illuminateYellow();
		this.dataLoaderService.flagDictionary.alternateOverlayFlag = true;
		let index: number = -1;
		if (this.dataLoaderService.vehicleInfo.urlFlag === '0' || this.dataLoaderService.vehicleInfo.urlFlag === '1') {
			let returnAlternateValues = this.alternateOptionsService.getAlternateOptionsNormal(item);
			returnAlternateValues.subscribe(
				alternateResponse => {
					if (alternateResponse.suggestions[0].addedCodes.length > 0 || alternateResponse.suggestions[0].removedCodes.length > 0) {
						this.rimSuggList = alternateResponse.suggestions;
						this.commonDataService.sendSuggestion(this.rimSuggList);
						this.openAlternateScreen();
						this.dataLoaderService.flagDictionary.loadingFlag = false;
					}
					else {
						for (let i in this.rim) {
							if (this.rim[i].code === item.code) {
								this.dataLoaderService.previousExpertRim[0] = this.rim[i];
								this.rim[i].selected = true;
								this.alternateScreenComponent.updatedPrices();
							} else {
								this.rim[i].selected = false;

								//Updated prices from validation response
								for (let s in this.dataLoaderService.gccUpdatedPrices) {
									for (let k in this.rim) {
										if (this.rim[k].code == this.dataLoaderService.gccUpdatedPrices[s].code && this.rim[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType) {
											this.rim[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;}
									}
								}
							}
						}
						this.saved = item;
						this.dataLoaderService.flagDictionary.alternateOverlayFlag = false;
						this.dataLoaderService.flagDictionary.loadingFlag = false;
						if (this.commonDataService.progressBarNewOrderColorFlag == true && this.commonDataService.progressBarNewOrderUpholsteryFlag == true) {
							setTimeout(() => {
								this.progressService.illuminateGreen();
							}, 0);
						}
						this.saveRim();

					}
					this.sortingService.sortCodes(this.rim, true)
				},
				err => {
					if (err._body !== undefined) {
						this.errMessage = err._body;
						this.commonDataService.notifyErrorMsgItem(this.errMessage);
						this.openAlternateErrorScreen();
						this.dataLoaderService.flagDictionary.loadingFlag = false;
					}
				}
			);
		} else {

			for (let i in this.rim) {
				if (this.rim[i].code === item.code) {
					this.rim[i].selected = true;
				} else {
					this.rim[i].selected = false;
				}
			}
			this.flag = this.itemCheck(item);
			if (this.flag) {
				this.saved = item;
			}
			this.dataLoaderService.flagDictionary.validated = false;
			this.dataLoaderService.flagDictionary.alternateOverlayFlag = false;
			this.dataLoaderService.flagDictionary.loadingFlag = false;
			this.sortingService.sortCodes(this.rim, true)
			this.saveRim();
		}
		this.progressService.progressBarValidation();
	}

	/**
	 * To go to the next Tab: Additional Color tab when clicked on the Continue button
	 * @param none
	 * @returns none
	 */
	gotoNextTab() {
		if (!this.dataLoaderService.flagDictionary.noTrimOptions) {
			this.commonDataService.notifyOther({ option: 'activeTrim' });
		}
		else {
			this.commonDataService.notifyOther({ option: 'activeFactory' });
		}
	}
	saveRim() {
		if (this.saved !== undefined) {
			this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalRim", data: [this.saved] });
			this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertRim", data: [this.saved] });
			this.priceCalculationService.normalModePriceCalculation();
		} else if (this.flag == false && this.saved == undefined) {
			this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalRim", data: [] });
			this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertRim", data: [] });
			this.priceCalculationService.normalModePriceCalculation();
		}
		this.progressService.progressBarValidation();
	}

	itemCheck(item): boolean {
		let index: number = -1;
		if (this.saved !== undefined) {
			for (let j in this.rim) {
				if (item.code === this.rim[j].code && item === this.saved) {
					this.rim[j].selected = false;
					this.flag = false;
					this.saved = undefined;
					return this.flag;
				}
			}
		}
		this.flag = true;
		return this.flag;
	}

	openAlternateScreen() {
		if (this.dataLoaderService.vehicleInfo.urlFlag === '0' || this.dataLoaderService.vehicleInfo.urlFlag === '1') {
			this.dataLoaderService.flagDictionary.alternateErrorFlag = false;
			this.dataLoaderService.flagDictionary.alternateValidateFlag = true;
			this.progressService.illuminateRed();

		}
	}
	openAlternateErrorScreen() {
		this.dataLoaderService.flagDictionary.alternateErrorFlag = true;
		this.dataLoaderService.flagDictionary.alternateValidateFlag = false;
		this.progressService.illuminateRed();

	}
	validate() {
		this.summaryValidationComponent.alternateOptionsForURLFlag2Validate();
		this.sortingService.sortCodes(this.rim, true);
	}


}



// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/normal-screen-components/rim/rim.component.ts